import type { FC } from "react";
import type { ITableCellProps } from "../interfaces/ITableCellProps";
import { i18nCategoryFilter, categoryIconFilter, subCategoryFilter } from "app/filters/ngFilters";

export const CategoryNoLinkCell: FC<ITableCellProps> = ({ value, row, isIconHidden }) => {
    return (
        <div
            className="swTable-categoryCell"
            title={i18nCategoryFilter()(value)}
        >
            {!isIconHidden ? <i className={`sprite-category ${categoryIconFilter()(row.Category)}`}></i> : null}
            {subCategoryFilter()(value)}
        </div>
    );
};
CategoryNoLinkCell.displayName = "CategoryNoLinkCell";
